<template>
  <div class="historyNotice">
    <el-dialog
      title="历史公示"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="900px"
      :before-close="close"
    >
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="发布时间" width="240" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="标题名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.title || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="200" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span class="blue_Box" @click="details(row)">查看详情</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="历史公示详情"
      :visible.sync="detailsDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="900px"
      :before-close="detailsClose"
    >
      <div style="padding: 0 20px">
        <div class="notice_title">{{ noticeData.title }}</div>
        <div class="notice_time">发布时间：{{ noticeData.insertDate }}</div>
        <div class="notice_content">
          <div v-html="noticeData.content"></div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailsClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getIllegalPublicityListPage } from "@/api/organization/violationNotice.js";
import myPagination from "@/components/myPagination.vue";
export default {
  components: {
    myPagination,
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      detailsDialogVisible: false,
      data: [],
      noticeData: {},
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
    };
  },
  methods: {
    // 初始化
    init() {
      this.getIllegalPublicityListPage({ page: 1, limit: 10 });
      this.dialogVisible = true;
    },
    // 查看详情
    details(row) {
      this.noticeData = row;
      this.detailsDialogVisible = true;
    },
    // 请求列表
    async getIllegalPublicityListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getIllegalPublicityListPage({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getIllegalPublicityListPage({
        page: payload,
        limit: this.pageInfo.limit,
      });
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getIllegalPublicityListPage({ page: 1, limit: payload });
    },
    // 关闭
    close() {
      this.dialogVisible = false;
    },
    // 关闭详情
    detailsClose() {
      this.detailsDialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.historyNotice {
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }

  .notice_title {
    font-size: 28px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .notice_time {
    font-size: 16px;
    margin-top: 14px;
    margin-bottom: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .notice_content {
    font-size: 14px;
    ::v-deep img {
      width: 100%;
    }
  }
}
</style>